import { Injectable, inject } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants, checkComposeNodeId, deepCopy, getUniqueName, isDateTimeGetTimeSeconds, makeid, removeUndefined, reviveTimestamps } from 'na-lib';
import { Template } from 'na-lib';
import { prepareDataToFirestoreUpdates, removeUndefinedValuesFromObject } from 'na-lib';
import { CommentsService } from './comments.service';
import { collection, collectionData, deleteDoc, deleteField, doc, docData, setDoc, serverTimestamp, updateDoc, getDocs, writeBatch, Firestore } from '@angular/fire/firestore';
import { firstValueFrom, Observable } from 'rxjs';

export interface PassChild {
  id: string;
  name: string;
  widgets: any[];
  translations: any;
  languages: string[];
  enableShoppingCart?: boolean;
  enableCustomerLogin?: boolean;
  contextId?: string
  contentType?: string
  creationDate?: any
}

@Injectable({
  providedIn: 'root'
})
export class PassDefinitionsService {
  db = inject(Firestore)
  newPassId:any={}
  contextCDData:any
  private readonly draftCollection = 'PassDefinitionDrafts'

  constructor(private settingsService: SettingsService,
    private commentsService: CommentsService) { }

  async createPassDefinition(passDefinitionName:string, contentypeId, languages):Promise<string>{
    return new Promise(async (resolve,reject)=> {
      try{
        this.commentsService.progressSpin.emit(true)

        const docRef = doc( collection(this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_PASSDEFINITIONS) )
        const newid = docRef.id

        this.newPassId[contentypeId]=newid
        let newPass = {}
        newPass['id'] = docRef.id
        newPass['contextId'] = this.settingsService.contextId$
        newPass['creationDate'] = new Date()
        newPass['timeStamp'] = new Date()
        newPass['widgets'] = []
        newPass['name'] = passDefinitionName
        newPass['languages'] = languages

        if (this.settingsService.contextAccount$?.design){
          const cdSettings = this.settingsService.contextAccount$?.design
          if(cdSettings.theme && cdSettings.theme.fonts){
            if(cdSettings.theme.fonts.title){
              if(!cdSettings.theme.fonts.title.url || !cdSettings.theme.fonts.title.name ){
                delete cdSettings.theme.fonts.title
              }
            }

            if(cdSettings.theme.fonts.subtitle){
              if(!cdSettings.theme.fonts.subtitle.url || !cdSettings.theme.fonts.subtitle.name ){
                delete cdSettings.theme.fonts.subtitle
              }
            }

            if(cdSettings.theme.fonts.plain ){
              if(!cdSettings.theme.fonts.plain.url || !cdSettings.theme.fonts.plain.name ){
                delete cdSettings.theme.fonts.plain
              }
            }

            if(cdSettings.theme.fonts.italic ){
              if(!cdSettings.theme.fonts.italic.url || !cdSettings.theme.fonts.italic.name ){
                delete cdSettings.theme.fonts.italic
              }
            }

            if(cdSettings.theme.fonts.bold ){
              if(!cdSettings.theme.fonts.bold.url || !cdSettings.theme.fonts.bold.name ){
                delete cdSettings.theme.fonts.bold
              }
            }

            const fonts = Object.keys(cdSettings.theme.fonts)
            if(fonts.length==0)
            delete cdSettings.theme.fonts

          }
          newPass['theme'] = cdSettings.theme
        }

        removeUndefinedValuesFromObject(newPass)
        await setDoc( docRef, newPass)

        resolve(newid)
        this.commentsService.progressSpin.emit(false)

      }catch(error){
        this.commentsService.progressSpin.emit(false)
        reject(error)
        console.log(error)
      }
    })
  }

  updatePassDefinition(passDefinition:Template): Promise<void>{
    return new Promise(async (resolve,reject)=> {
      const data = removeUndefinedValuesFromObject(passDefinition)

      try{
        data['timeStamp'] = new Date()
        const newdata = prepareDataToFirestoreUpdates(passDefinition)
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinition.id)
        await updateDoc( docRef, newdata)

        resolve()
      }
      catch(error){
        reject(error)
        console.log(error)
      }
    })
  }
  setPassDefinition(passDefinition: Template): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const cleanedData = removeUndefinedValuesFromObject(passDefinition);
        cleanedData['timeStamp'] = new Date();

        const updateData: any = {};
        for (const [key, value] of Object.entries(cleanedData)) {
          // Keep valid values, delete null or empty string values
          if (value == null || value === '') {
            updateData[key] = deleteField()
          } else {
            updateData[key] = value;
          }
        }

        const docRef = doc(this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinition.id)
        await setDoc( docRef, updateData, {merge:true})

        resolve();
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }

  updatePassDefinitionAfterUpdateContentType(passDefinitionId:string, passDefinitionName:string): Promise<void>{
    return new Promise(async (resolve, reject) => {

      const data = {name: passDefinitionName, id: passDefinitionId}
      try{
        data['timeStamp'] = new Date()
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinitionId)
        await updateDoc( docRef, data)
        resolve()
      }catch(error){
        reject(error)
      }
    })

  }

  resetNewPassId(contentypeId){
    delete this.newPassId[contentypeId]
  }

  deletePassDefinition(passDefinitionId:string){
    return new Promise(async (resolve, reject) => {
      try {
        const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinitionId)
        const d  = await deleteDoc( docRef)
        resolve(d)
      } catch (error) {
        reject(error)
        console.log(error)
      }
    })
  }


  async importPassDefinition(passDefinition, contentypeId):Promise<string>{
    return new Promise(async (resolve,reject)=> {
      try{

        const passDefinitionsRefaa = doc( collection(this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_PASSDEFINITIONS) )
        const newid = passDefinitionsRefaa.id

        this.newPassId[contentypeId]=newid

        let newPass = reviveTimestamps(passDefinition);

        newPass['id'] = passDefinitionsRefaa.id
        newPass['contextId'] = this.settingsService.contextId$
        if(newPass['contentType'])
          newPass['contentType'] = contentypeId
        newPass['timeStamp'] = new Date()

        const existingPassDefinitions = this.settingsService.settingsPassDefinitionsWithId ?? []
        const existingNames = existingPassDefinitions.map(pd => pd?.name)

        const importedName = `${newPass['name'] ?? ''} import_`
        newPass['name'] = getUniqueName(importedName, existingNames)

        const docRef = doc( this.db,NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, NetworkConstants.COLLECTION_PASSDEFINITIONS, newid )
        await setDoc( docRef, newPass)

        resolve(newid)

      }catch(error){
        reject(error)
        console.log(error)
      }
    })
  }

  observePassDefinitionDrafts(contextId: string): Observable<any[]> {
    const draftsCol = collection(this.db, NetworkConstants.COLLECTION_CONTEXTS, contextId, this.draftCollection);
    return collectionData(draftsCol, { idField: 'id' }) as Observable<any[]>;
  }

  async getPassDefinitionDraft(passDefinitionId: string): Promise<any | false> {
    try {
      const ref = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, this.draftCollection, passDefinitionId);
      const draft: any = await firstValueFrom(docData(ref, { idField: 'id' }));
      return draft || false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  getPassDraftChildren(passDefinitionId: string): Promise<PassChild[]> {
    return this.getPassChildrenFromCollection(this.draftCollection, passDefinitionId);
  }

  async setPassDefinitionDraft(passDefinition: Template | any): Promise<void> {
    try {
      const cleanedData = removeUndefinedValuesFromObject(passDefinition);
      cleanedData['timeStamp'] = new Date();

      const updateData: any = {};
      for (const [key, value] of Object.entries(cleanedData)) {
        if (value == null || value === '') {
          updateData[key] = deleteField();
        } else {
          updateData[key] = value;
        }
      }

      const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, this.draftCollection, passDefinition.id);
      await setDoc(docRef, updateData, { merge: true });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  setPassDraftChildren(passDefinitionId: string, children: PassChild[]): Promise<void> {
    return this.setPassChildrenInCollection(this.draftCollection, passDefinitionId, children);
  }

  async publishPassDefinitionDraft(passDefinitionId: string): Promise<void> {
    const draft = await this.getPassDefinitionDraft(passDefinitionId);
    if (!draft) return;

    const draftChildren = await this.getPassDraftChildren(passDefinitionId);
    await this.setPassDefinition(draft);
    await this.setPassChildren(passDefinitionId, draftChildren);
    await this.deletePassDefinitionDraft(passDefinitionId);
  }

  async deletePassDefinitionDraft(passDefinitionId: string): Promise<void> {
    try {
      const childrenCol = collection(
        this.db,
        NetworkConstants.COLLECTION_CONTEXTS,
        this.settingsService.contextId$,
        this.draftCollection,
        passDefinitionId,
        'Children'
      );
      const childrenSnap = await getDocs(childrenCol);
      const batch = writeBatch(this.db as any);
      let hasChildDeletes = false;
      childrenSnap.forEach((docSnap) => {
        hasChildDeletes = true;
        batch.delete(docSnap.ref);
      });
      if (hasChildDeletes) await batch.commit();

      const draftRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$, this.draftCollection, passDefinitionId);
      await deleteDoc(draftRef);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  getPassChildren(passDefinitionId: string): Promise<PassChild[]> {
    return this.getPassChildrenFromCollection(NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinitionId);
  }

  private getPassChildrenFromCollection(collectionName: string, passDefinitionId: string): Promise<PassChild[]> {
    return new Promise<PassChild[]>(async (resolve, reject) => {
      try {
        const childrenCol = collection(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          collectionName,
          passDefinitionId,
          'Children'
        );

        const snap = await getDocs(childrenCol);
        const result: PassChild[] = snap.docs.map((docSnap) => {
          const data: any = docSnap.data();

          return {
            id: docSnap.id,
            name: data?.name ?? '',
            widgets: data?.widgets ?? [],
            translations: data?.translations ?? {},
            languages: data?.languages ?? [],
            enableShoppingCart: data?.enableShoppingCart,
            enableCustomerLogin: data?.enableCustomerLogin,
            creationDate: data?.creationDate ?? data?.timeStamp
          };
        });

        resolve(result);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }

  setPassChildren(
    passDefinitionId: string,
    children: PassChild[]
  ): Promise<void> {
    return this.setPassChildrenInCollection(NetworkConstants.COLLECTION_PASSDEFINITIONS, passDefinitionId, children);
  }

  private setPassChildrenInCollection(
    collectionName: string,
    passDefinitionId: string,
    children: PassChild[]
  ): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const childrenCol = collection(
          this.db,
          NetworkConstants.COLLECTION_CONTEXTS,
          this.settingsService.contextId$,
          collectionName,
          passDefinitionId,
          'Children'
        );

        const snap = await getDocs(childrenCol);
        const batch = writeBatch(this.db as any);

        snap.forEach((docSnap) => batch.delete(docSnap.ref));

        for (const child of children) {
          const ref = doc(childrenCol, child.id);
          const payload: any = {
            contextId: child.contextId,
            contentType: child.contentType,
            id: child.id,
            name: child.name,
            widgets: child.widgets ?? [],
            translations: child.translations ?? {},
            languages: child.languages ?? [],
            enableShoppingCart: !!child.enableShoppingCart,
            enableCustomerLogin: !!child.enableCustomerLogin,
            creationDate: child.creationDate ?? new Date(),
            timeStamp: serverTimestamp(),
          };

          removeUndefinedValuesFromObject(payload);
          batch.set(ref, payload, {merge:true});
        }

        await batch.commit();
        resolve();
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }


  cleanTemplateBeforeSave(oldTemplateData:any, newPasDefinitonValues:any){
    //remove lat, lng values of maps before saving on firestore
    const newPasDefinitonValuesCleanedMap = deepCopy(newPasDefinitonValues)
    if(newPasDefinitonValuesCleanedMap.widgets){
      newPasDefinitonValuesCleanedMap.widgets.forEach(async (widget:any) => {
        if(widget.type == 'annotatedMap'){
          if(widget.annotations){
            widget.annotations.forEach((annotation:any) => {
              if(annotation.lat && annotation.lng){
                if(annotation.coordinate){
                  annotation['coordinate'] = [annotation['lat'], annotation['lng']]
                }
                delete annotation['lat']
                delete annotation['lng']
              }
  
              if(annotation.dynamic){ // NAR-5041
                if(annotation.source === "workTasks")
                  annotation.source = "payload"
              }
            });
          }
        }
  
        if(widget.type == 'countdown'){
          if(widget.targetDate){
            const date = isDateTimeGetTimeSeconds(widget.targetDate)
            const newdate = new Date(date)
            const minDate = new Date('1970-01-01T00:00').getTime()
  
            if (newdate.getTime() < 0 || isNaN(newdate.getTime())) {
              if(minDate > newdate.getTime())
                widget.targetDate = new Date(minDate)
            }else{
              widget.targetDate = newdate
            }
          }
        }
  
        //add if any from images is missing id
        if(widget.type == 'images'){
          const missingId = widget?.images.find( (image:any) => !image.id)
          if(missingId){
            widget?.images.forEach((image:any) => {
              if(!image.id){
                image.id = makeid(5)
              }
            });
          }
  
        }
        //add if any from composed is missing id
        if(widget.type == 'composed'){
          await widget?.content.forEach((node:any) => {
            checkComposeNodeId(node)
          });
        }
        //--- uncomment this to autom. change videos to new structure withtype, layout
        // if(widget.type === 'video'){
        //   if(!widget.layout)
        //     widget.layout = 'standard'
        // }
  
        // if(widget.type === 'splashVideo'){
        //     widget.layout = 'splash'
        //     widget.type = 'video'
        // }
        // if(widget.type === 'billboardVideo'){
        //   widget.layout = 'billboard'
        //   widget.type = 'video'
        // }
      });
    }
  
    //delete '' translations
    const newPasDefinitonValuesCleanedTranslations = deepCopy(newPasDefinitonValuesCleanedMap)
    if(newPasDefinitonValuesCleanedTranslations.translations ){
      if(oldTemplateData.translations){
        const languages = Object.keys(newPasDefinitonValuesCleanedTranslations.translations)
        const translations = deepCopy(newPasDefinitonValuesCleanedTranslations.translations)
        const oldTranslations = deepCopy(oldTemplateData.translations)
  
        languages.forEach ( (language, index) => {
          if(translations[language]){
            const keys = Object.keys(translations[language])
            keys.forEach(key => {
              const idKeyField = key.split('.')
              const id = idKeyField[0]
  
              if(newPasDefinitonValuesCleanedTranslations.widgets && newPasDefinitonValuesCleanedTranslations.widgets.length!=0){
                if(!newPasDefinitonValuesCleanedTranslations.widgets.find( (widget:any) => id.includes(widget.id))){
                  // if(!newPasDefinitonValuesCleanedTranslations.widgets.find( widget => widget.id == id)){
                  newPasDefinitonValuesCleanedMap.translations[language][key] = deleteField()
                  delete newPasDefinitonValues.translations[language][key]
  
                }else{
                  let value = translations[language][key]
  
                  // if( value == ''){
                  //   if(!oldTranslations[language] || !oldTranslations[language][key] || oldTranslations[language][key]== ''){
                  //     value = undefined
                  //   }
                  // }
                  if(!value && oldTranslations && oldTranslations[language] && oldTranslations[language][key]){
                    newPasDefinitonValuesCleanedMap.translations[language][key] = deleteField()
                    delete newPasDefinitonValues.translations[language][key]
                  }
                }
              }else{
                newPasDefinitonValuesCleanedMap.translations = deleteField()
                delete newPasDefinitonValues.translations
              }
  
            })
  
            if(keys.length == 0){
              newPasDefinitonValuesCleanedMap.translations[language] = deleteField()
              delete newPasDefinitonValues.translations[language]
            }
          }
        })
  
        if( Object.keys(translations).length != 0){
          removeUndefined(translations)
          newPasDefinitonValues.translations == translations
        }else{
          // newPasDefinitonValues.translations == undefined
          // newPasDefinitonValuesCleanedMap.translations = deleteField()
        }
      }
      //delete translations of languages not included
      if(newPasDefinitonValuesCleanedTranslations.translations && newPasDefinitonValuesCleanedTranslations.languages){ // this.oldTemplateData.languages
        const languages = newPasDefinitonValuesCleanedTranslations.languages
        const firstLanguage = newPasDefinitonValuesCleanedTranslations.languages[0]
        removeUndefined(newPasDefinitonValuesCleanedTranslations.translations)
        removeUndefined(newPasDefinitonValuesCleanedMap.translations)
        removeUndefined(newPasDefinitonValues.translations)
        // if(JSON.stringify(languages) != JSON.stringify(oldTemplateData.languages)){
          const translations = Object.keys(newPasDefinitonValuesCleanedTranslations.translations)
          translations.forEach( lang => {
            if(!languages.includes(lang) || lang == firstLanguage ){
              newPasDefinitonValuesCleanedMap.translations[lang] = {}
              newPasDefinitonValuesCleanedMap.translations[lang] = deleteField()
              delete newPasDefinitonValues.translations[lang]
            }
          })
        // }
      }
    }
    return {newPasDefinitonValuesCleanedMap, newPasDefinitonValues}
  }

}
